import { render, staticRenderFns } from "./AlcorTabLink.vue?vue&type=template&id=5cac7912&lang=pug"
import script from "./AlcorTabLink.vue?vue&type=script&lang=js"
export * from "./AlcorTabLink.vue?vue&type=script&lang=js"
import style0 from "./AlcorTabLink.vue?vue&type=style&index=0&id=5cac7912&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports